/* eslint-disable array-callback-return */
import React, { useState, useRef, useContext, useEffect } from "react"
import { Fieldset } from "primereact/fieldset"
import PropTypes from "prop-types"
import { Toast } from "primereact/toast"
import { Toolbar } from "primereact/toolbar"
import { Dropdown } from "primereact/dropdown"
import CustomToolBar from "../../../ToolBar/customToolbar"
import {
  arrestedTimes,
  confirmationRefused,
  paroleTypes,
  drugCourtProgram,
} from "../../../types/dropDownTypes"
import { errorMessages } from "../../../types/messages"
import {
  existsErrors,
  getAdditionalQuestions,
  showMessage,
  showQuestion,
  updateState,
  validateQuestions,
  formatMixedQuestions,
  filterAdditionalQuestions,
  checkDisplayConditional,
  checkConditionalRender,
  nextForm,
  prevForm,
} from "../../../utils/utils"
import { endpoints } from "../../../../../config/gpraApiEndpoints"
import { GpraContext } from "../../../../../context/gpraContext"
import { InputNumber } from "primereact/inputnumber"
import FormLabel from "../../../Common/FormLabel"
import FormError from "../../../Common/FormError"
import gpraStyles from "../../../../../styles/Participant-GPRA.module.css"
import {
  INTERVIEW_SECTIONS,
  INTERVIEW_TYPES,
} from "../../../types/interviewTypes"
import AdditionalQuestionContainer from "../../Additional/AdditionalQuestionContainer"
import { UserContext } from "../../../../../context/userContext"

const Legal = (props) => {
  const { showToolBar, disabled } = props
  const {
    handleSubmitPut,
    interview,
    handleLoadPrev,
    handleLoadNext,
    sectionsCompleted,
    handleSectionsCompleted,
    questions,
    updateInterviewValues,
    additionalQuestions,
    sections,
    activeIndex,
    administrativeInterview,
    interviewType,
    editMode,
  } = useContext(GpraContext)

  const userCtx = useContext(UserContext)

  const [legal, setLegal] = useState(interview[INTERVIEW_SECTIONS.LEGAL])
  const [validationErrors, setValidationErrors] = useState({})

  const [mixedQuestions, setMixedQuestions] = useState([])

  useEffect(() => {
    if (mixedQuestions.length === 0) {
      let filteredQuestions = []
      let filteredAdditional = []
      if (questions) {
        filteredQuestions = questions.filter(
          (q) =>
            q.section === INTERVIEW_SECTIONS.LEGAL &&
            !q.field.endsWith("section")
        )
      }
      if (additionalQuestions) {
        filteredAdditional = filterAdditionalQuestions(
          additionalQuestions,
          INTERVIEW_SECTIONS.LEGAL
        )
      }
      setMixedQuestions(
        formatMixedQuestions(filteredQuestions, filteredAdditional)
      )
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [questions, additionalQuestions])

  const toast = useRef(null)

  const saveData = (setNextForm, previousForm, setNavigationItem) => {
    updateInterviewValues(INTERVIEW_SECTIONS.LEGAL, legal)
    if (previousForm) {
      handleLoadPrev(true)
      setNextForm(prevForm(sections, activeIndex, administrativeInterview))
      setNavigationItem()
    } else {
      if (validForm()) {
        handleLoadNext(true)
        handleSubmitPut(endpoints.SAVE_LEGAL_DATA, {
          GpraE1: legal?.gpra_e_1,
          GpraE1Num: legal?.gpra_e_1_num,
          GpraE2: legal?.gpra_e_2,
          GpraE3: legal?.gpra_e_3,
          GpraE4: legal?.gpra_e_4,
          GpraInterviewId:
            interview[INTERVIEW_SECTIONS.RECORD_MGMT].interview_id,
          GpraEId: legal?.gpra_e_id,
          Additional: getAdditionalQuestions(legal),
          EditMode: editMode,
          EditedBy: userCtx.session?.user?.staff_id,
        })
          .then((response) => {
            if (response.status === 200 || response.status === 201) {
              updateInterviewValues(INTERVIEW_SECTIONS.LEGAL, {
                ...legal,
                gpra_e_id: response.data.gpraEId,
              })
              handleLoadNext(false)
              setNextForm(
                nextForm(
                  sections,
                  activeIndex,
                  interviewType !== INTERVIEW_TYPES.INTAKE
                    ? administrativeInterview
                    : true
                )
              )
              setNavigationItem()
              handleSectionsCompleted({
                ...sectionsCompleted,
                ...{ legal: true },
              })
            }
          })
          .catch((error) => {
            handleLoadNext(false)
            showMessage(false, errorMessages.genericError, toast)
          })
      } else {
        showMessage(false, errorMessages.toastErrorDetail, toast)
      }
    }
  }

  const removeError = (key) => {
    validationErrors[key] = null
    setValidationErrors(validationErrors)
  }

  const validForm = () => {
    const errors = {}
    if (
      legal?.gpra_e_1_num === 0 &&
      !legal?.gpra_e_1 &&
      showQuestion(questions, "gpra_e_1")
    ) {
      errors.gpra_e_1 = errorMessages.requiredMessage
    }
    if (!legal?.gpra_e_2 && showQuestion(questions, "gpra_e_2")) {
      errors.gpra_e_2 = errorMessages.requiredMessage
    }
    if (!legal?.gpra_e_3 && showQuestion(questions, "gpra_e_3")) {
      errors.gpra_e_3 = errorMessages.requiredMessage
    }
    if (!legal?.gpra_e_4 && showQuestion(questions, "gpra_e_4")) {
      errors.gpra_e_4 = errorMessages.requiredMessage
    }
    setValidationErrors(
      validateQuestions(
        legal,
        INTERVIEW_SECTIONS.LEGAL,
        additionalQuestions,
        errors,
        questions
      )
    )
    return existsErrors(errors)
  }

  const renderDefaultMain = (question) => {
    if (question.field === "gpra_e_1") {
      return (
        <div className={gpraStyles.formRow}>
          <FormLabel
            label={`${question.number}. In the past 30 days, how many times have you been arrested? [IF THE CLIENT INDICATES NO ARRESTS IN THE PAST 30 DAYS, BUT IS INCARCERATED AT THE TIME OF THE INTERVIEW, MARK CURRENTLY INCARCERATED]`}
            required
          />
          <InputNumber
            className={
              validationErrors.gpra_e_1
                ? gpraStyles.numberError
                : gpraStyles.inputNumber
            }
            value={
              !legal?.gpra_e_1_num && question.defaultZero
                ? 0
                : legal?.gpra_e_1_num
            }
            onValueChange={(e) => {
              updateState(
                "gpra_e_1_num",
                e.value,
                null,
                null,
                legal,
                setLegal,
                [{ key: "gpra_e_1", value: "" }]
              )
              removeError("gpra_e_1")
            }}
            showButtons
            min={0}
            disabled={disabled || legal?.gpra_e_1}
            suffix=" times"
          />
          <Dropdown
            value={legal?.gpra_e_1}
            onChange={(e) => {
              removeError("gpra_e_1")
              if (e.value === "Refused") {
                updateState("gpra_e_1", e.value, null, null, legal, setLegal, [
                  { key: "gpra_e_1_num", value: undefined },
                ])
              } else {
                updateState(
                  "gpra_e_1",
                  e.value,
                  null,
                  null,
                  legal,
                  setLegal,
                  null
                )
              }
            }}
            disabled={legal?.gpra_e_1_num > 0 || disabled}
            options={arrestedTimes}
            optionLabel="label"
            optionValue="value"
            showClear={legal?.gpra_e_1}
            className={
              validationErrors.gpra_e_1
                ? gpraStyles.input4Error
                : gpraStyles.input4
            }
          />
          <FormError error={validationErrors.gpra_e_1} />
        </div>
      )
    }
    if (question.field === "gpra_e_2") {
      return (
        <div className={gpraStyles.formRow}>
          <FormLabel
            label={`${question.number}. Are you currently awaiting charges, trial, or sentencing?`}
            required
          />
          <Dropdown
            value={legal?.gpra_e_2}
            onChange={(e) => {
              updateState(
                "gpra_e_2",
                e.value,
                null,
                null,
                legal,
                setLegal,
                null
              )
              removeError("gpra_e_2")
            }}
            disabled={disabled}
            options={confirmationRefused}
            optionLabel="label"
            optionValue="value"
            showClear={legal?.gpra_e_2}
            className={
              validationErrors.gpra_e_2
                ? gpraStyles.input4Error
                : gpraStyles.input4
            }
          />
          <FormError error={validationErrors.gpra_e_2} />
        </div>
      )
    }
    if (question.field === "gpra_e_3") {
      return (
        <div className={gpraStyles.formRow}>
          <FormLabel
            label={`${question.number}. Are you currently on parole or probation or intensive pretrial supervision?`}
            required
          />
          <Dropdown
            value={legal?.gpra_e_3}
            onChange={(e) => {
              updateState(
                "gpra_e_3",
                e.value,
                null,
                null,
                legal,
                setLegal,
                null
              )
              removeError("gpra_e_3")
            }}
            disabled={disabled}
            options={paroleTypes}
            optionLabel="label"
            optionValue="value"
            showClear={legal?.gpra_e_3}
            className={
              validationErrors.gpra_e_3
                ? gpraStyles.input4Error
                : gpraStyles.input4
            }
          />
          <FormError error={validationErrors.gpra_e_3} />
        </div>
      )
    }
    if (question.field === "gpra_e_4") {
      return (
        <div className={gpraStyles.formRow}>
          <FormLabel
            label={`${question.number}. Do you currently participate in a drug court program or are you in a deferred prosecution agreement?`}
            required
          />
          <Dropdown
            value={legal?.gpra_e_4}
            onChange={(e) => {
              updateState(
                "gpra_e_4",
                e.value,
                null,
                null,
                legal,
                setLegal,
                null
              )
              removeError("gpra_e_4")
            }}
            disabled={disabled}
            options={drugCourtProgram}
            optionLabel="label"
            optionValue="value"
            showClear={legal?.gpra_e_4}
            className={
              validationErrors.gpra_e_4
                ? gpraStyles.input4Error
                : gpraStyles.input4
            }
          />
          <FormError error={validationErrors.gpra_e_4} />
        </div>
      )
    }
  }
  return (
    <div>
      <Toast ref={toast} />
      {showToolBar && (
        <Toolbar
          className={gpraStyles.mb2}
          right={
            <CustomToolBar
              prevForm={true}
              saveData={saveData}
              nextForm={true}
              toast={toast}
            />
          }
        ></Toolbar>
      )}

      <Fieldset legend="E. LEGAL" style={{ marginBottom: "1rem" }}>
        <div className={gpraStyles.grid}>
          {mixedQuestions?.map((question) => {
            if (question.kind === "default") {
              if (question.show) {
                return renderDefaultMain(question)
              }
            } else {
              if (
                checkConditionalRender(
                  question.enabled,
                  question.required,
                  question.kind,
                  question.conditionalSource
                )
              ) {
                return (
                  <AdditionalQuestionContainer
                    entity={legal}
                    setEntity={setLegal}
                    errors={validationErrors}
                    section={INTERVIEW_SECTIONS.LEGAL}
                    removeError={removeError}
                    disabled={disabled}
                    question={question.question}
                    number={question.number}
                    kind={question.kind}
                  />
                )
              } else {
                if (checkDisplayConditional(question, legal)) {
                  return (
                    <AdditionalQuestionContainer
                      entity={legal}
                      setEntity={setLegal}
                      errors={validationErrors}
                      section={INTERVIEW_SECTIONS.LEGAL}
                      removeError={removeError}
                      disabled={disabled}
                      question={question.question}
                      number={question.number}
                      kind={question.kind}
                    />
                  )
                }
              }
            }
          })}
        </div>
      </Fieldset>
    </div>
  )
}

Legal.propTypes = {
  showToolBar: PropTypes.bool,
  disabled: PropTypes.bool,
}

Legal.defaultProps = {
  showToolBar: true,
  disabled: false,
}

export default Legal
